// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Skeleton du profil : placeholders clairs + balayage shimmer. */
.profil-skeleton {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Brique shimmer de base. */
.pskel {
  display: block;
  border-radius: 6px;
  background-color: #e6e8eb;
  background-image: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.65),
    transparent
  );
  background-size: 200% 100%;
  background-repeat: no-repeat;
  background-position: -150% 0;
  animation: pskel-shimmer 1.4s ease-in-out infinite;
}
@keyframes pskel-shimmer {
  to {
    background-position: 150% 0;
  }
}

/* En-tete (titre + pastille). */
.profil-skel-topbar {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 0.5rem;
}
.pskel-title {
  width: 22rem;
  height: 2.6rem;
  border-radius: 8px;
}
.pskel-pill {
  width: 9rem;
  height: 1.8rem;
  border-radius: 999px;
}

/* Barre d'onglets factice. */
.profil-skel-tabs {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}
.pskel-tab {
  width: 12rem;
  height: 3rem;
  border-radius: 8px 8px 0 0;
}

/* Section : bandeau gris (comme .section-header) + grille de champs. */
.profil-skel-section {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}
.profil-skel-section-header {
  height: 3.2rem;
  background: #595959;
  opacity: 0.9;
}
.profil-skel-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.6rem;
  padding: 1.6rem;
  background: #fff;
}
.profil-skel-field {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}
.pskel-label {
  width: 40%;
  height: 1.1rem;
}
.pskel-input {
  width: 100%;
  height: 3.4rem;
  border-radius: 8px;
}

@media screen and (max-width: 768px) {
  .profil-skel-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/Skeleton/ProfilSkeleton.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB;;;;;GAKC;EACD,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,kDAAkD;AACpD;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,uEAAuE;AACvE;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Skeleton du profil : placeholders clairs + balayage shimmer. */\n.profil-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n/* Brique shimmer de base. */\n.pskel {\n  display: block;\n  border-radius: 6px;\n  background-color: #e6e8eb;\n  background-image: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.65),\n    transparent\n  );\n  background-size: 200% 100%;\n  background-repeat: no-repeat;\n  background-position: -150% 0;\n  animation: pskel-shimmer 1.4s ease-in-out infinite;\n}\n@keyframes pskel-shimmer {\n  to {\n    background-position: 150% 0;\n  }\n}\n\n/* En-tete (titre + pastille). */\n.profil-skel-topbar {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n.pskel-title {\n  width: 22rem;\n  height: 2.6rem;\n  border-radius: 8px;\n}\n.pskel-pill {\n  width: 9rem;\n  height: 1.8rem;\n  border-radius: 999px;\n}\n\n/* Barre d'onglets factice. */\n.profil-skel-tabs {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n}\n.pskel-tab {\n  width: 12rem;\n  height: 3rem;\n  border-radius: 8px 8px 0 0;\n}\n\n/* Section : bandeau gris (comme .section-header) + grille de champs. */\n.profil-skel-section {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.profil-skel-section-header {\n  height: 3.2rem;\n  background: #595959;\n  opacity: 0.9;\n}\n.profil-skel-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.6rem;\n  padding: 1.6rem;\n  background: #fff;\n}\n.profil-skel-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n.pskel-label {\n  width: 40%;\n  height: 1.1rem;\n}\n.pskel-input {\n  width: 100%;\n  height: 3.4rem;\n  border-radius: 8px;\n}\n\n@media screen and (max-width: 768px) {\n  .profil-skel-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
